const tableTitleManagementService = {
  title: 'Gestión de Servicios',
  placeholder: 'Buscar',
  addRowLabel: 'nuevo servicio',
  excelGenerateToaster: 'Exportando 2000 primeras coincidencias'
};

export default tableTitleManagementService;
